// eslint-disable-next-line import/prefer-default-export
export const SHOPIFY_SPECIFIC_PARAMS = {
  sortBy: 'sort_by',
  page: 'page',
  view: 'view',
};

export const SORT_BY_PRICE_HIGH_TO_LOW = 'price-descending';
export const SORT_BY_PRICE_LOW_TO_HIGH = 'price-ascending';
